import React from 'react'
import {Input, Button} from 'reactstrap'
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome'

const ProjectFileUpload = (props) => {

    return (
        <div className="d-flex flex-row justify-content-start">
            <Button size="sm" color="success">
                <FontAwesomeIcon color="#fff" icon="file-upload"/>{' '}
                Upload
            </Button>
        </div>
    )

}

export default ProjectFileUpload